import type { FC } from 'react';

import { formatPublishDate } from '@/utils/timeUtils';

import type { BreadcrumbItem } from '@/components/Breadcrumb';
import { Breadcrumb } from '@/components/Breadcrumb';
import type { ContentfulBreadcrumbFragment } from '@/graphql/contentful/api';
import { Tag } from '@/views/NewsView/components/Tags/TagsFilter.styles';
import { Title } from '@/views/NewsView/News.styles';

import { CMSSection } from '../CMSSection';

import * as S from './NewsHeader.styles';

interface NewsHeaderProps {
  breadcrumb: {
    cms?: ContentfulBreadcrumbFragment;
    items?: BreadcrumbItem[];
  };
  pageTitle?: string;
  publishDate: string;
  shortDescription?: string;
  tagsCollection?: {
    __typename: string;
    items: Array<{
      value?: string | null;
    } | null>;
  };
}

export const NewsHeader: FC<NewsHeaderProps> = ({
  breadcrumb,
  pageTitle,
  publishDate,
  shortDescription,
  tagsCollection,
}) => {
  return (
    <>
      {breadcrumb.cms && (
        <CMSSection withMargin={false}>
          <Breadcrumb.Wrapper>
            <Breadcrumb
              inverted={breadcrumb.cms?.style === 'Light'}
              items={breadcrumb.items ?? []}
            />
          </Breadcrumb.Wrapper>
        </CMSSection>
      )}
      <S.NewsHeaderContainer>
        <S.TopArea>
          {tagsCollection?.items && tagsCollection?.items?.length > 0 && (
            <S.TagWrapper>
              {tagsCollection.items.map((tag, index) => (
                <Tag key={`${tag?.value}_${index}`}>{tag?.value}</Tag>
              ))}
            </S.TagWrapper>
          )}

          {pageTitle && (
            <S.ContentWrapper>
              <Title>{pageTitle}</Title>
            </S.ContentWrapper>
          )}

          {publishDate && (
            <S.NewsTitle>{formatPublishDate(publishDate)}</S.NewsTitle>
          )}
        </S.TopArea>

        {shortDescription && (
          <S.ContentWrapper>
            <S.NewsDescription>{shortDescription}</S.NewsDescription>
          </S.ContentWrapper>
        )}
      </S.NewsHeaderContainer>
    </>
  );
};
